import { forwardRef, type InputHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/shared/lib/cn';

const inputVariants = cva(
  'flex w-full text-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 file:border-0 file:bg-transparent file:text-sm file:font-medium',
  {
    variants: {
      variant: {
        outline:
          'h-10 rounded-md border border-input bg-background px-3 shadow-sm focus-visible:ring-2 focus-visible:ring-ring',
        filled:
          'h-12 rounded-lg border border-transparent bg-secondary px-4 text-[15px] shadow-none focus-visible:border-ring focus-visible:bg-background focus-visible:ring-2 focus-visible:ring-ring/40',
      },
    },
    defaultVariants: { variant: 'outline' },
  },
);

export type InputProps = InputHTMLAttributes<HTMLInputElement> &
  VariantProps<typeof inputVariants>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(inputVariants({ variant }), className)}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
